import { css, unsafeCSS } from "lit";
import { sbkCoreBreakpointMd, sbkCoreBreakpointXl } from "@/tokens/variables";

const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);
const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const style = css`
    :host {
        --link-border-focus: var(--_link-border-focus, var(--sbkLinkBorderOnLightFocus));
        --link-color: var(--_link-color, var(--sbkLinkFgColorOnLightEnabled));
        --link-color-hover: var(--_link-color-hover, var(--sbkLinkFgColorOnLightHover));
        --link-color-active: var(--_link-color-active, var(--sbkLinkFgColorOnLightActive));
        --link-color-disabled: var(--_link-color-disabled, var(--sbkLinkFgColorOnLightDisabled));
        --link-color-visited: var(--_link-color-visited, var(--sbkLinkFgColorOnLightVisited));
        --link-color-selected: var(--_link-color-selected, var(--sbkLinkFgColorOnLightSelected));
        box-sizing: border-box;
        display: inline-block;
    }

    :host([variant="underlined"]) {
        display: inline;
        position: relative;
    }

    .link-wrapper {
        display: flex;
        align-items: center;

        &.link-wrapper-underlined {
            .link {
                white-space: normal;
            }

            @media all and (min-width: ${breakpointMd}) {
                &.link--parent-infobox {
                    display: inline;

                    .link {
                        white-space: nowrap;
                    }
                }
            }
            &:not(.link--parent-infobox) {
                display: inline;
            }

            @media all and (max-width: ${breakpointXl}) {
              height: 100%;
            }

          .link {
            position: relative;
            display: inline;
            background-color: unset;
            outline: 2px solid transparent;
            outline-offset: 2px;
            border: none;
            cursor: pointer;
            color: var(--link-color);
            padding: 0;
            text-align: left;
            overflow-wrap: break-word;
            word-break: break-word;
            hyphens: auto;
            transition: text-decoration 0.3s;
            width: fit-content;
            text-decoration-color: transparent;
            text-decoration-thickness: 2px;
            text-decoration-line: underline;
            text-underline-offset: 4px;
            margin-right: -1px;

            @media all and (min-width: ${breakpointMd}) {
                white-space: nowrap;
            }

            &.link--inBodytext {
                white-space: normal;
                word-break: keep-all;
                overflow-wrap: normal;
                hyphens: none;
            }

            &.break-all {
              word-break: break-all;
            }

            &.link--icon-position-left {
                padding-left: 30px;

                @media all and (min-width: ${breakpointMd}) {
                    padding-left: 25px;
                }

              &.link-underlined-xs {
                padding-left: 20px;

                sbk-icon {
                  left: -20px;
                  top: 2px;
                }
              }

            sbk-icon {
                left: -30px;
                top: 0;
            }

            @media all and (min-width: ${breakpointMd}) {
                .link__icon {
                    margin-right: var(--sbkLinkSpacing4xs);
                }

                sbk-icon {
                    left: -25px;
                    top: 0;
                }
            }

            }

            &.link--icon-position-right {
              &.link-underlined-xs {
                sbk-icon {
                  top: 2px;
                }
              }

              .link__icon {
                margin-left: var(--sbkLinkSpacing4xs);
              }

              sbk-icon {
                right: -22px;
                top: 0;
                @media all and (min-width: ${breakpointXl}) {
                            right: -20px;
                        }
                    }
                }
            }

            sbk-icon {
                position: absolute;
            }
        }
    }

    .link-wrapper.right {
        margin-right: 24px;
        &.link-xs {
            margin-right: 20px;
        }
        @media all and (max-width: ${breakpointXl}) {
          height: 100%;
        }
    }

  .link {
    display: flex;
    background-color: unset;
    gap: var(--sbkLinkSpacing4xs);
    align-items: flex-start;
    outline: transparent solid 2px;
    outline-offset: var(--sbkLinkBorderGapFocus);
    border-radius: var(--sbkLinkBorderRadiusFocus);
    border: none;
    cursor: pointer;
    text-decoration: none;
    color: var(--link-color);
    fill: currentcolor;
    padding: 0px;
    font: inherit;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    hyphens: manual;

    &.break-all {
      word-break: break-all;
    }

    &.link-icon-navigation {
      font: var(--sbkLinkBold2xs);
      align-items: center;
      @media all and (max-width: ${breakpointXl}) {
        flex-direction: column;
      }

      .link__text {
        display: none;
        @media all and (max-width: ${breakpointXl}) {
          display: block;
        }
      }
    }

    .link__text {
      align-self: center;
    }

    .link__icon {
      position: relative;
      top: 0;
    }

    &.link-underlined-md {
            .link__icon {
                margin-top: 0;
            }
        }

        sbk-icon {
            &.xs {
                height: 20px;
            }
            &.size-2xs {
                height: 20px;
            }

            @media all and (min-width: ${breakpointXl}) {
                ~ .link__text {
                    position: relative;
                    top: -2px;
                }
            }
        }

        &:not(.link--selected):visited {
            color: var(--link-color-visited);
        }

        &:not(.link--selected):active {
            color: var(--link-color-active);

            .link__text {
                text-decoration: underline;
            }
        }

        &:focus-visible {
            outline: var(--link-border-focus);
        }

        @media (hover: hover) and (pointer: fine) {
            &:not(.link--selected):hover {
                @media all and (min-width: ${breakpointMd}) {
                    color: var(--link-color-hover);

                    .link__text {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .link--selected {
        color: var(--link-color-selected);
    }

    .link--disabled {
        color: var(--link-color-disabled);
        cursor: not-allowed;
        margin: 0;
        padding: 0;
        display: inline-block;
        outline: 2px solid transparent;
        outline-offset: var(--sbkLinkBorderGapFocus);
        border-radius: var(--sbkLinkBorderRadiusFocus);
        border: none;
        text-decoration: none;
        fill: currentColor;
    }

    .link-regular-bold {
        font-weight: 700;
    }

    .link-regular-2xs {
        font: var(--sbkLinkRegular2xs);
    }

    .link-regular-xs {
        font: var(--sbkLinkRegularXs);
    }

    .link-regular-sm {
        font: var(--sbkLinkRegularSm);
    }

    .link-regular-md {
        font: var(--sbkLinkRegularMd);
    }

    .link-icon-navigation-bold {
        font-weight: 700;
        align-items: center;
        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }

        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-icon-navigation-2xs {
        align-items: center;
        font: var(--sbkLinkRegular2xs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-xs {
        font: var(--sbkLinkRegularXs);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-sm {
        font: var(--sbkLinkRegularSm);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-md {
        font: var(--sbkLinkRegularMd);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-2xs {
        font: var(--sbkLinkBold2xs);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-xs {
        font: var(--sbkLinkBoldXs);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-sm {
        font: var(--sbkLinkBoldSm);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-md {
        font: var(--sbkLinkBoldMd);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-reduced-navigation-bold {
        font-weight: 700;
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-2xs {
        font: var(--sbkLinkRegular2xs);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-xs {
        font: var(--sbkLinkRegularXs);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-sm {
        font: var(--sbkLinkRegularSm);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-md {
        font: var(--sbkLinkRegularMd);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-2xs {
        font: var(--sbkLinkBold2xs);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-xs {
        font: var(--sbkLinkBoldXs);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-sm {
        font: var(--sbkLinkBoldSm);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-md {
        font: var(--sbkLinkBoldMd);
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-navigation {
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-bold {
        font-weight: 700;
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-2xs {
        font: var(--sbkLinkRegular2xs);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-xs {
        font: var(--sbkLinkRegularXs);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-sm {
        font: var(--sbkLinkRegularSm);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-md {
        font: var(--sbkLinkRegularMd);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-underlined {
        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-bold {
        text-decoration: underline;
        font-weight: 700;
    }

    .link-underlined-2xs {
        font: var(--sbkLinkUnderlined2xs);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-xs {
        font: var(--sbkLinkUnderlinedXs);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-sm {
        font: var(--sbkLinkUnderlinedSm);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-md {
        font: var(--sbkLinkUnderlinedMd);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-regular-bold-2xs {
        font: var(--sbkLinkBold2xs);
    }

    .link-regular-bold-xs {
        font: var(--sbkLinkBoldXs);
    }

    .link-regular-bold-sm {
        font: var(--sbkLinkBoldSm);
    }

    .link-regular-bold-md {
        font: var(--sbkLinkBoldMd);
    }

    .link-underlined-bold-xs {
        font: var(--sbkLinkBoldUnderlinedXs);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-bold-sm {
        font: var(--sbkLinkBoldUnderlinedSm);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-bold-md {
        font: var(--sbkLinkBoldUnderlinedMd);

        .link__text {
            text-decoration: underline;
        }
    }

    .link.link--noHyphens {
        hyphens: none;
        word-break: keep-all;
    }
`;
